import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { BankingInfo } from '../classes/banking-info';

@Injectable()
export class BankingInfoService {

  constructor(private http: Http) { }

  getBankingInfos(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(`${environment.organizationsUrl}${orgId}/${environment.bankingInfoUrl}`, options)
      .map(res => res.json())
  }

  addBankingInfo(orgId: number, info: BankingInfo) {
    let data = { banking_information: info, commit: 'Add', organization_id: orgId };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.post(`${environment.organizationsUrl}${orgId}/${environment.bankingInfoUrl}`, data, options)
      .map(res => res.json())
  }

  editBankingInfo(orgId: number, id: number, info: BankingInfo) {
    let data = { banking_information: info, commit: 'Add', organization_id: orgId, id };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.patch(`${environment.organizationsUrl}${orgId}/organization_setups/banking_informations/${id}.json`, data, options)
      .map(res => res.json())
  }

  deleteBankingInfo(orgId: number, id: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.delete(`${environment.organizationsUrl}${orgId}/organization_setups/banking_informations/${id}.json`, options)
      .map(res => res.json())
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/banking-info.service.ts